

import React, { useEffect, useState } from "react";
import { Offcanvas, Form, Button, Col, Row, Card } from "react-bootstrap";

const EventModal = ({
  showModal,
  handleClose,
  eventData,
  addevent,
  editevent,
  eventId,
  type
}) => {
  const [formData, setFormData] = useState({
    title: '',
    start_date: '',
    end_date: '',
    location: '',
    description: '',
    attachment: '',
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (showModal && !eventData) {
      // reset form
      setFormData({
        title: '',
        start_date: '',
        end_date: '',
        location: '',
        description: '',
        attachment: '',
      });
    } else if (eventData) {
      // edit mode
      setFormData({
        ...eventData
      });
    }
  }, [eventData, showModal]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: undefined }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.title) newErrors.title = "Name is required";


    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    let apierrors;
    if (eventData) {
      apierrors = await editevent(eventId, formData);
    } else {
      apierrors = await addevent(formData);
    }

    if (apierrors && Object.keys(apierrors).length > 0) {
      setErrors(apierrors);
    } else {
      setErrors({});
      handleClose();
    }
  };

  return (
    <Offcanvas
      show={showModal}
      onHide={handleClose}
      placement="end"
      style={{ width: "450px" }}
    >
      <Offcanvas.Header closeButton className="bg-light">
        <Offcanvas.Title className="fw-bold">
          {eventData ? "Edit Event" : "Add New Event"}
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body className="p-4" style={{ overflowY: 'auto' }}>
        <Form onSubmit={handleSubmit}>
          {/* Personal Information Section */}
          <div className="mb-4">

            <Form.Group className="mb-3">
              <Form.Label className="form-label form-font"> Name *</Form.Label>
              <Form.Control
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                isInvalid={!!errors.title}
                className="form-control form-feild"
              />
              <Form.Control.Feedback type="invalid">
                {errors.name}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="form-label form-font">Start Date </Form.Label>
              <Form.Control
                type="date"
                name="start_date"
                value={formData.start_date}
                onChange={handleChange}
                className="form-control form-feild"
              />
            </Form.Group>





            <Form.Group className="mb-3">
              <Form.Label className="form-label form-font">Location</Form.Label>
              <Form.Control
                type="text"
                name="location"
                value={formData.location}
                onChange={handleChange}
                className="form-control form-feild"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="form-label form-font">End Date</Form.Label>
              <Form.Control
                type="date"
                name="end_date"
                value={formData.end_date}
                onChange={handleChange}
                className="form-control form-feild"
              />
            </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label className="form-label form-font">Description</Form.Label>
                <Form.Control
                  type="text"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  className="form-control form-feild"
                />
              </Form.Group>



              <Form.Group className="mb-3">
  <Form.Label className="form-label form-font">Attachment</Form.Label>
  <Form.Control
    type="file"
    name="attachment"
    onChange={(e) =>
      setFormData({ ...formData, attachment: e.target.files[0] })
    }
    className="form-control form-feild"
  />
</Form.Group>


          </div>

          <div className="d-flex justify-content-end mt-4">
            <Button variant="outline-secondary" onClick={handleClose} className="me-2">
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Save
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default EventModal;